// extracted by mini-css-extract-plugin
module.exports = {"body":"ModelList_body__3WPGC","toolbar":"ModelList_toolbar__3p6HN","table":"ModelList_table__1etjO","form":"ModelList_form__38Brd","editRemark":"ModelList_editRemark__JNaT-"};